"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createHandler = _interopRequireDefault(require("./createHandler"));

var _createObserver = _interopRequireDefault(require("./createObserver"));

var _propTypes2 = require("../propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var hasWindow = typeof window !== "undefined";
/**
 * Uses the `IntersectionObserver` API to toggle events when child elements
 * appear in the browser viewport.
 */

var InView = _react.default.forwardRef(function (_ref, ref) {
  var _classNames;

  var children = _ref.children,
      unobserveAfterEntry = _ref.unobserveAfterEntry,
      _observerOptions = _ref.observerOptions,
      _className = _ref.className,
      _inViewClassName = _ref.inViewClassName,
      _style = _ref.style,
      _inViewStyle = _ref.inViewStyle,
      onEnter = _ref.onEnter,
      onExit = _ref.onExit; // Set up state value to track when element is in view

  var _useState = (0, _react.useState)(hasWindow ? null : true),
      _useState2 = _slicedToArray(_useState, 2),
      inViewport = _useState2[0],
      setInViewport = _useState2[1]; // Set up ref for element being observed


  var el = (0, _react.useRef)(); // // Set up ref for the observer

  var observer = (0, _react.useRef)(); // Set up ref to track first time element is observed in viewport
  // IntersectionObserver returns false on page load, so we can use this to
  // avoid running the callback passed for `onExit`

  var hasEntered = (0, _react.useRef)(); // Set up IntersectionObserver once DOM is loaded

  (0, _react.useEffect)(function () {
    if (el.current && hasWindow) {
      // Set up IntersectionObserver options
      var observerOptions = _objectSpread({
        rootMargin: "0px",
        // rootMargin must be specified in pixels or percent
        threshold: 0.5
      }, _observerOptions); // Create the handler function that gets called when the target
      // element intersects the window


      var handler = (0, _createHandler.default)(el.current, setInViewport, _objectSpread({}, observerOptions, {
        unobserveAfterEntry: unobserveAfterEntry
      })); // Stop current observer if it exists

      if (observer.current) {
        observer.current.disconnect();
      } // Create new observer and save on a ref


      observer.current = (0, _createObserver.default)(handler, el.current, observerOptions);
    }

    return function () {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [_observerOptions, unobserveAfterEntry]); // This allows the parent component to get access to the
  // InterSectionObserver instance

  if (ref) {
    (0, _react.useImperativeHandle)(ref, function () {
      return {
        getObserver: function getObserver() {
          return observer.current;
        },
        getElement: function getElement() {
          return el.current;
        }
      };
    });
  } // Handle triggering callbacks


  (0, _react.useEffect)(function () {
    if (inViewport) {
      hasEntered.current = true;

      if (onEnter) {
        onEnter();
      }
    } else if (!inViewport && hasEntered.current && onExit) {
      onExit();
    }
  }, [inViewport, onEnter, onExit]); // Build list of classNames from props.
  // As a convenience, we can pass the baseClassName and inViewClassName as
  // an array to the `className` prop; otherwise we can pass them as separate props

  var className = Array.isArray(_className) ? _className[0] : _className;
  var inViewClassName = Array.isArray(_className) && _className[1] ? _className[1] : _inViewClassName; // Do the same for styles

  var style = Array.isArray(_style) ? _style[0] : _style;
  var inViewStyle = Array.isArray(_style) && _style[1] ? _style[1] : _inViewStyle;
  return _react.default.createElement("div", {
    ref: el,
    className: (0, _classnames.default)((_classNames = {
      CosmicInView: true
    }, _defineProperty(_classNames, "".concat(className), true), _defineProperty(_classNames, "".concat(inViewClassName), inViewport === true), _classNames)),
    style: _objectSpread({}, style, {}, inViewport === true ? inViewStyle : {})
  }, children);
});

InView.propTypes = {
  children: _propTypes.default.node,
  unobserveAfterEntry: _propTypes.default.bool,
  observerOptions: _propTypes.default.shape({
    rootMargin: _propTypes.default.string,
    threshold: _propTypes.default.number
  }),
  className: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  inViewClassName: _propTypes.default.string,
  style: _propTypes2.styleProps,
  inViewStyle: _propTypes2.styleProps,
  onEnter: _propTypes.default.func,
  onExit: _propTypes.default.func
};
InView.defaultProps = {
  children: null,
  unobserveAfterEntry: false,
  observerOptions: {},
  className: "",
  inViewClassName: "",
  style: {},
  inViewStyle: {},
  onEnter: null,
  onExit: null
};
var _default = InView;
exports.default = _default;